var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThunderSvgrepoCom1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2090_39858)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7269 0C15.103 6.81429e-06 15.4548 0.189907 15.6666 0.507261C15.8784 0.82462 15.9228 1.22838 15.7853 1.58586L12.6897 9.63409H17.8154C18.3031 9.63409 18.7365 9.9516 18.8927 10.4234C19.0489 10.8951 18.8932 11.416 18.5056 11.7183L3.06303 23.7617C2.66914 24.0688 2.12577 24.0801 1.71997 23.7895C1.31418 23.499 1.13942 22.9734 1.28798 22.4906L4.52918 11.9567H1.13714C0.739209 11.9567 0.370248 11.7442 0.164244 11.3965C-0.0417605 11.0489 -0.0548175 10.6165 0.129818 10.2565L5.07115 0.622464L5.09007 0.587024C5.29168 0.225042 5.66867 0 6.07847 0H14.7269ZM3.01644 9.63409H6.07847C6.44053 9.63409 6.78096 9.81015 6.99519 10.1082C7.20942 10.4063 7.27187 10.7908 7.16334 11.1435L4.53269 19.6931L14.4527 11.9567H11.0213C10.6452 11.9567 10.2935 11.7668 10.0817 11.4494C9.86984 11.132 9.82538 10.7282 9.96288 10.3708L13.0585 2.32258H6.76652L3.01644 9.63409Z",
    fill: "#06362B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2090_39858"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunderSvgrepoCom1);
export default __webpack_public_path__ + "static/media/thunder-svgrepo-com 1.7f7e849a80878fcc7a989f8e02b0ae90.svg";
export { ForwardRef as ReactComponent };